import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'instructionsLabel'
	| 'noInstructions'
	| 'knowledgeSourcesLabel'
	| 'skillsLabel'
	| 'noSkills';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		instructionsLabel: {
			id: 'rovo.agent.scenarios.scenarioModal.instructionsLabel',
			defaultMessage: 'Instructions',
			description: 'Section heading label for the agent scenario instructions in the modal',
		},
		noInstructions: {
			id: 'rovo.agent.scenarios.scenarioModal.noInstructions',
			defaultMessage: 'No instructions',
			description: 'Placeholder shown in scenario modal when no instructions are defined',
		},
		knowledgeSourcesLabel: {
			id: 'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel',
			defaultMessage: 'Knowledge',
			description: 'Section heading label for knowledge sources listed in the scenario modal',
		},
		skillsLabel: {
			id: 'rovo.agent.scenarios.scenarioModal.skillsLabel',
			defaultMessage: 'Skills',
			description: 'Section heading label for agent skills listed in the scenario modal',
		},
		noSkills: {
			id: 'rovo.agent.scenarios.scenarioModal.noSkills',
			defaultMessage: 'No skills',
			description: 'Placeholder shown in scenario modal when no skills are configured',
		},
	});

export default message;
